import { useState } from 'react';
import './ShowMore.css';

const ShowMore = (props: { userMapLength: number; onShowMore?: () => void }) => {
  const [showBlock, setShowBlock] = useState(false);
  const showMore = (e: any) => {
    props.onShowMore?.();
    const parent = e?.currentTarget?.parentElement || e?.target?.parentElement;
    const cardEl =
      parent?.querySelector?.('.card') ||
      parent?.children?.[0] ||
      parent?.childNodes?.[0];

    const showMoreHeading = cardEl?.classList || e?.target?.parentElement?.childNodes[0]?.classList;
    if (showMoreHeading) {
      if (showMoreHeading.length <= 1 || !showMoreHeading.contains?.('showMoreActive')) {
        showMoreHeading.add?.('showMoreActive');
        try {
          showMoreHeading.value = 'card showMoreActive';
        } catch (_) {}
      }
      setShowBlock(true);
    }
  };

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (props.userMapLength < 11) {
    return null;
  }

  return (
        <>
          {!showBlock ? (
            <button
              className="t-text-cta t-block t-text-center t-mt-l t-py-r showMoreClass"
              aria-label="show more cards button"
              onClick={showMore}
            >
              Load more
            </button>
          ) : (
            <button
              className="backToTop t-mt-l t-mb-b"
              aria-label="Back to top of page button"
              onClick={handleScrollToTop}
            >
              <i className="t-icon t-icon-arrow-up" aria-label="upper arrow"></i>Back to Top
            </button>
          )}
        </>
  );
};

export default ShowMore;
